import { CalendarDay, clinicClockFor } from "@/lib/clinic-clock";
import { formatDate, formatTime } from "@/lib/format-data";

import { BookingEventSession } from "@/types/booking-event";

// Sessions are wall-clock ("5–8pm at every location"), so they are shown on a
// fixed clock rather than the viewer's: UTC in, UTC out leaves the wall time as
// typed.
const WALL_CLOCK = clinicClockFor("UTC");

const wallTime = (day: string, minutes: number) =>
  formatTime(WALL_CLOCK.at(day as CalendarDay, minutes), true, "UTC");

/** "5:00 PM – 8:00 PM" */
export function formatSessionTimes(session: BookingEventSession): string {
  return `${wallTime(session.day, session.startMinute)} – ${wallTime(
    session.day,
    session.endMinute,
  )}`;
}

/** "Wednesday, November 5, 5:00 PM – 8:00 PM" */
export function formatSession(session: BookingEventSession): string {
  const day = formatDate(session.day, {
    weekday: "long",
    month: "long",
    day: "numeric",
  });
  return `${day}, ${formatSessionTimes(session)}`;
}

/** One session in full, or the first and last day of several. */
export function summarizeSessions(sessions: BookingEventSession[]): string {
  if (sessions.length === 0) return "";
  if (sessions.length === 1) return formatSession(sessions[0]);
  const days = sessions.map((session) => session.day).sort();
  const short = { month: "short", day: "numeric" } as const;
  return `${formatDate(days[0], short)} – ${formatDate(
    days[days.length - 1],
    short,
  )} · ${sessions.length} sessions`;
}
